import { UploadFileIcon } from '../../../../components';

export default function SubmittedIcon() {
  return (
    <span className='bg-info-100 grid h-50 w-50 place-items-center rounded-[50%]'>
      <UploadFileIcon className='text-info text-[100px]' />
    </span>
  );
}
